<template>
    <el-card shadow="hover" :body-style="{padding:'5px'}" class="lesson">
        <div class="header">
            <span>課堂練習</span>
        </div>
        <p class="title omit" :title="title">{{title}}</p>
        <div v-if="describe" class="time">
            <p>{{describe}}</p>
        </div>
        <div v-if="time" class="time">
            <i class="el-icon-time"></i>
            <p>{{time}}</p>
        </div>
    </el-card>
</template>
<script>
export default {
    props:{
        title: {
            type: String,
            default: ''
        },
        time: {
            type: String,
            default: ''
        },
        describe: {
            type: String,
            default: ''
        },
    }
}
</script>
<style lang="less" scoped>
.el-card, .el-message{
    border-radius: 8px;
}
.lesson {
    width: 230px;
    height: 190px;
    background: rgba(77,142,246,0.1);
    .title{
        margin-top: 13px;
        height: 22px;
        font-size: 16px;
        line-height: 22px;
        color: #404040;
    }
    .header{
        width: 220px;
        height: 40px;
        text-align: center;
        color: #fff;
        font-weight:600;
        font-size: 17px;
        line-height: 40px;
        margin-bottom: 20px;
        background-color: #4D8EF6;
        border-radius:6px 6px 0px 0px;
    }
    .time{
        display: flex;
        margin-top: 10px;
        height: 13px;
        width: 230px;
        font-size: 13px;
        line-height: 13px;
        color: #333333;
        p{
            margin-left: 4px;
        }
    }
}
</style>